// Entry point for home/landing page
import { initLanguagePicker } from '../language.js';
import { initSupportDrawer } from '../support.js';

// Initialize everything when the document is loaded
document.addEventListener('DOMContentLoaded', () => {
    // Initialize language picker and support drawer
    initLanguagePicker();
    initSupportDrawer();
});